var chunkToChildrenMap = {
	"5385": [
		7823,
		2506,
		4056,
		1869,
		8017,
		2702
	]
};
__webpack_require__.f.preload = (chunkId) => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.G);
};